import {createSelector} from 'reselect';

const getRecaptchaDetails = state => state.recaptcha;

export default createSelector(
  [getRecaptchaDetails],
  recaptchaDetails => recaptchaDetails?.token || '',
);
